import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { usePathname } from 'next/navigation';
import useCmsRouteParams from '../../src/global-state/cmsRouteParams/useCmsRouteParams';
const useRouteMatchMock = () => {
  const $ = _c(9);
  const pathname = usePathname();
  const params = useCmsRouteParams();
  let resolvedParams;
  let t0;
  let url;
  if ($[0] !== params || $[1] !== pathname) {
    resolvedParams = params && typeof params === "object" ? {
      ...params
    } : {};
    url = pathname || "/";
    t0 = Object.entries(resolvedParams).reduce(_temp, url);
    $[0] = params;
    $[1] = pathname;
    $[2] = resolvedParams;
    $[3] = t0;
    $[4] = url;
  } else {
    resolvedParams = $[2];
    t0 = $[3];
    url = $[4];
  }
  const path = t0;
  let t1;
  if ($[5] !== path || $[6] !== resolvedParams || $[7] !== url) {
    t1 = {
      isExact: true,
      params: resolvedParams,
      path,
      url
    };
    $[5] = path;
    $[6] = resolvedParams;
    $[7] = url;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  const match = t1;
  return match;
};
export default useRouteMatchMock;
function _temp(acc, t0) {
  const [key, value] = t0;
  return value ? acc.replace(value, `:${key}`) : acc;
}